module.exports = __webpack_public_path__ + "media/images/menu/channel_4_off-3b53f7e5a333e4ec79011241a92ab2c0.jpg";